// custom select2 adapters
// not in own file because I need to guarantee these are defined before ThemeJS.Functions

( function( $ ) {
  const Utils = $.fn.select2.amd.require('select2/utils');
  const MultipleSelection = $.fn.select2.amd.require('select2/selection/multiple');
	const ResultsList = $.fn.select2.amd.require('select2/results');

	//
	// SELECTION
	// 
  function MultiSelectTextSelectionAdapter($element, options) {
    MultiSelectTextSelectionAdapter.__super__.constructor.call(this, $element, options);
  }

  Utils.Extend(MultiSelectTextSelectionAdapter, MultipleSelection);

	// display as comma-sep text instead of pills
  MultiSelectTextSelectionAdapter.prototype.update = function (data) {
    this.clear()

		const placeholder = this.$element.attr('data-placeholder') || ''
    const texts = data.map( item => item.text ).filter( Boolean )
    const summary = texts.length ? texts.join( ', ' ) : placeholder

    const rendered = $('<span class="select2-custom-summary"></span>').text( summary )
    $( '.select2-selection__rendered', this.$selection ).append( rendered )
  };

	MultiSelectTextSelectionAdapter.prototype.render = function () {
		const $selection = MultiSelectTextSelectionAdapter.__super__.render.call(this)
		// no need to add style attrs since we're overwriting in theme scss
		const $arrow = $( `<span class='select2-selection__arrow' role='presentation'><b></b></span>` )
		$selection.append( $arrow )

		return $selection
	};

  window.MultiSelectTextSelectionAdapter = MultiSelectTextSelectionAdapter;

  
	//
	// RESULTS
	// 
  function MultiSelectCheckboxAdapter($element, options, dataAdapter) {
    MultiSelectCheckboxAdapter.__super__.constructor.call(this, $element, options, dataAdapter);
  }

  Utils.Extend(MultiSelectCheckboxAdapter, ResultsList);

	// filter by optgroup (called by a custom s2 method added in .bind below)
	function filterOptGroups ( $select, filter ) {
		filter = ( Array.isArray( filter ) ? filter : [ filter ] )
			.filter( Boolean )
			.map( x => parseInt(x) )

		if ( ! filter.length ) {
			$( 'optgroup', $select ).prop( 'disabled', false )
			$( 'optgroup option', $select ).prop( 'disabled', false )
			return
		}

		$( 'optgroup', $select ).each( function () {
			const $og = $(this)
			const ids = $og.data('id')?.toString().split( ',' ).map( x => parseInt(x, 10) ) ?? []
			const show = !ids.length || filter.some( id => ids.includes( id ) )
			$og.prop( 'disabled', !show )
			$( 'option', $og ).prop( 'disabled', !show )
		})

		filterInvalidSelections( $select )
	}

	// remove elements made invalid by filter
	function filterInvalidSelections ( $select ) {
		const instance = $select.data('select2');
		if ( !instance ) return
		instance.dataAdapter.current( data => {
			const values = data.map( item => item.id )
			if ( !values.length ) return;

			const $valid = $select.find('option').filter( function () {
				return !this.disabled && !$(this).closest('optgroup').prop('disabled')
			})
			const valid = new Set( $valid.map( ( _, el ) => el.value ).get() )
			const filtered = values.filter( v => valid.has(v) )

			// If any were removed, update the value
			if ( filtered.length !== values.length ) {
				$select.val( filtered ).trigger( 'change' );
			}
		});
	}

	// filter disabled optgroups completely so they aren't processed
	MultiSelectCheckboxAdapter.prototype.append = function (data) {
		// fixes desynch between <select> and dropdown due to s2 caching
		const values = new Set( this.$element.val() || [] );
		function checkSelectionRecursive(items) {
			items.forEach(item => {
				if (item.children) {
					checkSelectionRecursive(item.children);
				} else {
					item.selected = values.has(item.id);
				}
			});
		}
		if ( data && data.results ) {
			checkSelectionRecursive( data.results );
			data.results = data.results
				.filter( item => item.id || item.children ) // remove empty rows
				.filter( item => {
					if ( item.children && item.element && $( item.element ).is( 'optgroup' ) ) {
						return ! $( item.element ).prop('disabled')
					}
					return true
				})
		}
		MultiSelectCheckboxAdapter.__super__.append.call(this, data);
	}

	// append checkboxes
  MultiSelectCheckboxAdapter.prototype.option = function (data) {
		const $el = $( MultiSelectCheckboxAdapter.__super__.option.call(this, data) )
		$el.data('data', data);

		if (data.id && !data.children) {
			const inputID = `${ data._resultId}-input`

			const $label = $( `<label for='${ inputID }'>` ).text( data.text )
			const $checkbox = $( `<input id='${ inputID }' type="checkbox" disabled />` )
				.prop('checked', data.selected)

			const $container = $(`<div class='pseudo-check-wrap type--checkbox'>` )
				.append( $checkbox )
				.append( $label )

			// Replace existing contents
			$el.empty().append($container)
		}

    return $el.get(0);
  };


	MultiSelectCheckboxAdapter.prototype.render = function () {
		const $element = this.$element
		const clear_all_text = ThemeJS.Variables.i18n?.clear_all || 'Clear All'
		const $btn = $( `<button type='button'>${ clear_all_text }</button>` )

		$btn.on( 'mousedown', function (e) {
			e.preventDefault() // don't blur the select
			const instance = $element.data('select2');
			if ( !instance ) return
			instance.dataAdapter.current( data => {
				if ( data.length ) {
					$element
						.val(null)
						.trigger('change')
						.select2('close')
						.select2('open')
				}
			})
		})

		const $wrapper = $(`<div class='s2mscheck-wrap'>` )
		const $scroll = $( `<div class='results'>` )
		const $results = MultiSelectCheckboxAdapter.__super__.render.call(this)
		const $footer = $( `<div class='footer'>` )

		$scroll.append( $results )
		$footer.append( $btn )
		$wrapper.append( $scroll ).append( $footer )
		return $wrapper
	};


	// add listeners for toggle checkbox and register custom func for optgroup filter
	MultiSelectCheckboxAdapter.prototype.bind = function (container, $container) {
    MultiSelectCheckboxAdapter.__super__.bind.call(this, container, $container);
		const self = this;
		const $select = this.$element;

		container.on( 'select', e => toggleCheckbox( e.data, true ) );
		container.on( 'unselect', e => toggleCheckbox( e.data, false ) );

		function toggleCheckbox ( data, isChecked ) {
			const $optionEl = self.$results
				.find( '.select2-results__option' )
				.filter( function () {
					return $(this).data('data')?.id === data.id;
				});
			$( "input[type='checkbox']", $optionEl ).prop( 'checked', isChecked );
		}

		// Inject custom method into Select2 instance
		container.setOgFilter = filter => {
			filterOptGroups( $select, filter );
			if ( $select.select2('isOpen') ) {
				$select.select2('close').select2('open');
			}
		}
		
		container.on( 'open', () => {
			$( '.select2-container--open .select2-dropdown' ).addClass( 's2mscheck' )
		})
	}

  window.MultiSelectCheckboxAdapter = MultiSelectCheckboxAdapter;
})( jQuery );


/*--------------------------------------------*\
		Include Globally Useful JS Functions
\*--------------------------------------------*/

ThemeJS.Functions = (function ($, root) {

	function send_ajax_request(args) {
		args.data.nonce = ThemeJS.Variables.Ajax.nonce;
		$.post(ThemeJS.Variables.Ajax.url, args.data, function (response) {
			response = JSON.parse(response);
			if (!response.hasOwnProperty('data')) { response.data = {}; }
			if (response.success && typeof args.success == 'function') {
				args.success(response.data);
			} else if (!response.success && typeof args.error == 'function') {
				args.error(response.data);
			}
		});
	}

	function wp_rest_request ( args ) {
		let ajax_args = {
			method: ( args.method ?? 'GET' ).toString().toUpperCase(),
			url: `${ ThemeJS.Variables.WP_REST.root }${ args.endpoint }`,
			data: args.data,
			contentType: 'application/json; charset=utf-8',
			beforeSend ( xhr ) {
				xhr.setRequestHeader( 'X-WP-Nonce', ThemeJS.Variables.WP_REST.nonce );
			},
			success ( data ) {
				if ( typeof args.success == 'function' ) {
					args.success( data );
				}
			},
			error ( data ) {
				if ( typeof args.error == 'function' ) {
					args.error( data );
				}
			},
			complete ( data ) {
				if ( typeof args.complete == 'function' ) {
					args.complete( data );
			}
			}
		};
		if ( ajax_args.method != 'GET' ) {
			ajax_args.dataType = 'json';
			ajax_args.data = JSON.stringify( ajax_args.data );
		}
		return jQuery.ajax( ajax_args );
	}

	function get_query_parameter(name, url) {
		if (!url) url = window.location.href;
		name = name.replace(/[\[\]]/g, '\\$&');
		var regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)'),
			results = regex.exec(url);
		if (!results) return null;
		if (!results[2]) return '';
		return decodeURIComponent(results[2].replace(/\+/g, ' '));
	}

	let scrollbar_width = null;
	// taken from https://stackoverflow.com/questions/13382516/getting-scroll-bar-width-using-javascript
	function get_scrollbar_width() {
		if (scrollbar_width === null) {
			let outer = document.createElement('div');
			outer.style.visibility = 'hidden';
			outer.style.overflow = 'scroll';
			outer.style.msOverflowStyle = 'scrollbar';
			document.body.appendChild(outer);
			let inner = document.createElement('div');
			outer.appendChild(inner);
			scrollbar_width = (outer.offsetWidth - inner.offsetWidth);
			outer.parentNode.removeChild(outer);
		}
		return scrollbar_width;
	}

	document.querySelector(':root').style.setProperty('--scrollbar-width', `${get_scrollbar_width()}px`);

	function get_header_height () {
		return parseInt( getComputedStyle( document.querySelector( ':root' ) ).getPropertyValue( '--header-height' ) );
	}

	function scroll_to ( $target, options = {} ) {
		if ( $target.length ) {
			const direction = options.direction ?? 'all';
			const offset = options.offset ?? 0;
			const target = $target.offset().top - get_header_height() - offset;
			let scroll = true;
			switch ( direction ) {
				case 'up':
					scroll = target < window.scrollY;
					break;
				case 'down':
					scroll = target > window.scrollY;
					break;
			}
			if ( scroll ) {
				window.scroll({ top: target });
			}
		}
	}


	function init_select2 ( el, args = {}, reinit = false ) {
		let $el = $(el);
		if ( $el.hasClass("select2-hidden-accessible") ) {
			if ( reinit ) {
				$el.select2('destroy');
			} else {
				return;
			}
		}
		let $gf_placeholder = $( 'option.gf_placeholder', $el );
		if ( $gf_placeholder.length ) {
			$el.attr( 'data-placeholder', $gf_placeholder.text() );
			$gf_placeholder.html('').removeClass( 'gf_placeholder' );
		}
		let has_empty_option = $( 'option', $el ).filter( function ( i, opt ) {
			let $opt = $(opt);
			let value = $opt.attr( 'value' );
			return ( value === undefined ) ? !$opt.text() : !value;
		}).length;

		const defaults = args = {
			minimumResultsForSearch: 6,
			closeOnSelect: $(el).data().close_on_select ?? true,
			allowClear: ( $el.attr( 'aria-required' ) != 'true' && has_empty_option ),
			templateResult: function ( state, li ) {
				if ( state.element ) {
					$( li ).css( '--depth', parseInt( state.element.attributes['data-depth']?.value ) );
				}
				$( state.element ).trigger( 'simplistics/select2/templateResult', [ state, li, el ] );
				return state.text;
			},
			...args,
		}

		if ( el.multiple ) {
			defaults.closeOnSelect = false
			defaults.escapeMarkup = x => x
			defaults.selectionAdapter = window.MultiSelectTextSelectionAdapter
			defaults.resultsAdapter = window.MultiSelectCheckboxAdapter
		}

		args = {
			...defaults,
			...args,
		}

		$el.select2( args );
	}
	$( 'select:not(.noinit)' ).each( function () {
		init_select2( this );
	});


	function get_extension ( path ) {
		const ind = path.lastIndexOf( '.' );
		return ( ind > 0 ) ? path.substring( ind + 1 ) : null;
	}


	function format_bytes ( bytes, decimals = 2 ) {
    if (!+bytes) return '0 Bytes';

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(bytes) / Math.log(k))

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
	}


	return {
		send_ajax_request,
		wp_rest_request,
		get_query_parameter,
		get_header_height,
		scroll_to,
		init_select2,
		get_extension,
		format_bytes,
	}

})(jQuery, this);